import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { NavTarget } from '../../components/link/link.component';
import { ZusatzangabenDetailEntryMeta } from '../../../core/gb-api/model/zusatzangabenDetailEntryMeta';
import { TranslateNamePipe } from '../../pipes/simple/translate-name.pipe';
import { DokulinkItemBuilderFactory } from 'app/shared/components/dokulink/dokulinkItemBuilderFactory';
import { GbgrundbuchgeschaeftService, GrundbuchgeschaeftRestDetailEntryMeta } from 'app/core/gb-api';
import { KompaktBelegComponent } from '../beleg/kompakt-beleg.component';
import { ReadMoreComponent } from '../../widgets/read-more/read-more.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { DatumPipe } from '../../pipes/simple/datum.pipe';

@Component({
  selector: 'cap-kompakt-zusatzangaben',
  templateUrl: './kompakt-zusatzangaben.component.html',
  styleUrls: ['./kompakt-zusatzangaben.component.scss'],
  imports: [NgTemplateOutlet, KompaktBelegComponent, ReadMoreComponent, NgbTooltip, TranslatePipe, DatumPipe]
})
export class KompaktZusatzangabenComponent extends KompaktdarstellungTemplateComponent implements OnInit, OnChanges {
  navTargets = NavTarget;

  @Input() zusatzangaben: ZusatzangabenDetailEntryMeta;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;

  @Output() openZusatzangabenEvent = new EventEmitter<ZusatzangabenDetailEntryMeta>();

  @Input() referenzObjectId: string;

  geschaeft: GrundbuchgeschaeftRestDetailEntryMeta;

  text: string;

  tooltipZusatzangaben = 'tooltipZusatzangaben';

  constructor(
    formatService: FormatConfigService,
    location: PlatformLocation,
    locationStrategy: ComponentLocationStrategy,
    private cdr: ChangeDetectorRef,
    private translateName: TranslateNamePipe,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory,
    private geschaeftService: GbgrundbuchgeschaeftService
  ) {
    super(formatService, 'ZUSATZANGABEN', location, locationStrategy);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.zusatzangaben?.beleg?.geschaeftId?.id) {
      this.geschaeftService.loadGbGeschaeftById(this.zusatzangaben?.beleg?.geschaeftId?.id).subscribe((m) => {
        this.geschaeft = m;
      });
    }
    const rechtsgrundCode =
      this.zusatzangaben.rechtsgrundCode && this.zusatzangaben.rechtsgrundCode.text
        ? this.translateName.transform(this.zusatzangaben.rechtsgrundCode.text)
        : '';
    this.text = rechtsgrundCode + (this.zusatzangaben.rechtsgrundZusatz ? ' ' + this.zusatzangaben.rechtsgrundZusatz : '');
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cdr.detectChanges();
  }

  openZusatzangaben() {
    this.openZusatzangabenEvent.emit(this.zusatzangaben);
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'ZUSATZANGABEN_TYP00');
  }
}
